import React from 'react';
import './DesignAuthorCard.scss'

const DesignAuthorCard = ({
  designerProfile
}) => {

  return (
    designerProfile && 
    <div className="design-author-container">
      <div className="design-author-pic" style={{ backgroundImage: `url(${designerProfile.partnerLogo.file.url})` }} />
      <div className="design-author-detail ">
        <div className="design-author-title">by {designerProfile.partnerName}</div>
        <div className="design-author-location">{designerProfile.partnerCountry}</div>
      </div>
    </div>
  )
}

export default DesignAuthorCard;